var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE1D52",
    fillRule: "evenodd",
    d: "M14.56 10.335a4.72 4.72 0 0 0 2.753.873V9.253a2.7 2.7 0 0 1-.576-.061v1.557a4.7 4.7 0 0 1-2.756-.883v4.02a3.655 3.655 0 0 1-5.675 3.033 3.655 3.655 0 0 0 6.255-2.554zm.714-1.994a2.73 2.73 0 0 1-.713-1.609v-.254h-.548a2.76 2.76 0 0 0 1.26 1.863Zm-5.7 7.03a1.668 1.668 0 0 1 1.338-2.68q.26 0 .508.077v-2.02a4 4 0 0 0-.58-.032v1.57a1.67 1.67 0 0 0-1.257 3.085z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.98 9.853a4.7 4.7 0 0 0 2.756.883V9.179a2.75 2.75 0 0 1-1.462-.838 2.76 2.76 0 0 1-1.261-1.863h-1.44v7.887a1.67 1.67 0 0 1-3 1.006 1.671 1.671 0 0 1 1.257-3.085v-1.57a3.652 3.652 0 0 0-2.524 6.203 3.654 3.654 0 0 0 5.684-3.033z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#69C9D0",
    fillRule: "evenodd",
    d: "M16.736 9.178v-.42a2.73 2.73 0 0 1-1.462-.417c.387.427.899.72 1.462.838Zm-2.723-2.7c0-.075-.023-.153-.033-.228v-.254h-1.987v7.89a1.67 1.67 0 0 1-1.67 1.661 1.65 1.65 0 0 1-.75-.176 1.671 1.671 0 0 0 3-1.006V6.478zm-3.183 4.235v-.446a3.652 3.652 0 0 0-2.524 6.652 3.652 3.652 0 0 1 2.534-6.19z",
    clipRule: "evenodd"
  })));
};
export default SvgTiktok;